import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Auth } from "aws-amplify";

import "./Login.css";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Backdrop, CircularProgress } from "@mui/material";
import errorMessages from "../../utils/errorMessagesUtil";
import { useForm } from "react-hook-form";
import { useAppProviderStore } from "store/appProviderCopyStore";
import { useNotification } from "hooks/useNotification";

function SendCodeForgotPassword() {
  const navigate = useNavigate();

  const { inputEmailForgotPassword } = useAppProviderStore();
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const { setNotify } = useNotification();

  //input 1
  const [showPassword1, setShowPassword1] = React.useState(false);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleMouseDownPassword1 = (event) => {
    event.preventDefault();
  };

  //input 2
  const [showPassword2, setShowPassword2] = React.useState(false);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };

  const {
    register,
    formState: { errors },
    trigger,
  } = useForm();


  const handleForgotPassword = async () => {
    setIsLoading(true);
    try {
      await Auth.forgotPassword(inputEmailForgotPassword);
      setNotify({
        isOpen: true,
        message: 'Código enviado, o envio pode levar alguns segundos, por favor verique seu email',
        type: "success",
        title:"Sucesso!"
      })
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      navigate("/login");
      setIsLoading(false);
    }
  };

  const forgotPasswordSubmit = async () => {
    setIsLoading(true);

    try {
      await Auth.forgotPasswordSubmit(inputEmailForgotPassword, code, password);
      navigate("/login");
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      //navigate("/login");
      setNotify({
        isOpen: true,
        message: errorMessages[err.message],
        type: "error",
        title:"Ops! Algo deu errado..."
      })
      setIsLoading(false);
    }
  };

  const enterPresskey = (event) => {
    if (event.keyCode === 13) {
      forgotPasswordSubmit()
    }
  }

  return (
    <div className="container_login" style={{ backgroundImage: "url(/img/bg-login.png)" }}>
      <div className="line_header_login"></div>
      <div className="login" style={{height:400}}>
        <div className="login_logo">
          <img src="/img/Logo_SescDigital_Pos.svg" alt="Logo" className="login_image" />
        </div>
        <div className="login_form">
          <div className="login_form_items">
            <p className="login_form_titulo" style={{marginTop:30, marginBottom:'2px'}}>Redefinir Senha</p>
            <div className="real_form">
              <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
                <CircularProgress color="inherit" />
              </Backdrop>
              <Box sx={{ lg: 1, width: "100%" }} onKeyDown={(e) => enterPresskey(e)}>
                <FormControl sx={{ lg: 1, width: "90%", marginBottom: "5%" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-email">Código de confirmação</InputLabel>
                  <Input id="standard-adornment-email" name="code" type="text" placeholder="Digite o código de confirmação" 
                  {...register("code", {
                     onChange: (e) => {setCode(e.target.value); trigger(e.target.name)},
                      required: true,
                    })}
                    onBlur={(evt) => {trigger( evt.target.name)}}
                    aria-invalid={errors.code? "true" : "false"}
                  />
                  {errors.code?.type === "required" && (
                    <p className="authFormError" role="alert">
                      Campo obrigatório.
                    </p>
                  )}
                </FormControl>
                <FormControl sx={{ lg: 1, width: "90%", marginBottom: "5%" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password" style={{marginTop:-5}}>Nova Senha</InputLabel>
                  <Input
                    id="standard-adornment-password"
                    type={showPassword1 ? "text" : "password"}
                    placeholder="Digite a senha"
                    name="password"
                    //onChange={(evt) => setPassword(evt.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword1} onMouseDown={handleMouseDownPassword1}>
                          {showPassword1 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>

                    }
                    {...register("password", {
                      onChange: (e) =>{setPassword(e.target.value); trigger(e.target.name)},
                      required: true,
                      pattern:
                      /(?=^.{8,}$)((?=.)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/
                    })}
                    aria-invalid={errors.password ? "true" : "false"}
                    onBlur={(evt) => {trigger( evt.target.name)}}
                  />
                  {errors.password?.type === "required" && (
                    <p className="authFormError" role="alert">
                    Campo obrigatório.
                    </p>
                  )}
                  {errors.password?.type === "pattern" && (
                    <p className="authFormError" role="alert">
                      Requisitos mínimos: 8 digitos, 1 caractere especial, 1 letra maiúscula e minúscula.
                    </p>)}
                </FormControl>

                <FormControl sx={{ lg: 1, width: "90%" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password">Confirmar Nova Senha</InputLabel>
                  <Input
                    id="standard-adornment-new-password"
                    type={showPassword2 ? "text" : "password"}
                    placeholder="Redigite a senha"
                    name="confirmPassword"
                    //onChange={(evt) => setnewPassword(evt.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword2} onMouseDown={handleMouseDownPassword2}>
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    {...register("confirmPassword", {
                      onChange: (e) => {trigger(e.target.name)},
                      required: true,
                      validate: (value) => value === password
                   })}
                    aria-invalid={errors.confirmPassword ? "true" : "false"}
                    onBlur={(evt) => trigger( evt.target.name)}
                  />
                  {errors.confirmPassword?.type === "required" && (
                    <p className="authFormError" role="alert">
                    Campo obrigatório.
                    </p>
                  )}
                  {errors.confirmPassword?.type === "validate" && (
                    <p className="authFormError" role="alert">
                     Senha diferente.
                    </p>)}
                </FormControl>
              </Box>
            </div>
            <div className="login_button">
              <button className="login_button_style" onClick={forgotPasswordSubmit}>
                Confirmar
              </button>
            </div>
            <div className="login_forgot_password" style={{margin:8}}>
              <a className="login_forgot_password_text" onClick={handleForgotPassword}>
                Reenviar código
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="line_bottom_login"></div>
    </div>
  );
}

export default SendCodeForgotPassword;
